<template>
  <main
    role="main"
    class="col content-spacing"
    style="max-width: 88% !important"
  >
    <section>
      <PageHeader pageTitle="Leads" style="padding-top: 1rem;">
        <div style="display: flex; gap: 0.5rem">
          <MunicipioSelect v-model="municipioList" />
          <CNAEFirstSelect
            :disabled="municipioList.length === 0"
            v-model="cnaeList"
            :selectedMunicipios="municipioList"
          />
        </div>
        <div style="display: flex; gap: 0.5rem; flex-direction: column;">
          Ano de início da atividade
          <div style="display: flex; gap: 0.5rem;">
            <SelectYear
              :startYear="1694"
              placeholderText="Ano inicial"
              v-model="minStartActivityYear"
              style="width: 150px;"
              revertYear
            />
            <SelectYear
              :startYear="computedMaxStartYear"
              placeholderText="Ano final"
              v-model="maxStartActivityYear"
              style="width: 150px;"
              revertYear
            />
          </div>
        </div>
        <BaseButtonComponent
          variant="primary-action"
          style="padding: 1px 12px;"
          :disabled="disableSearchButton"
          @click="getLeads"
        >
          Buscar
        </BaseButtonComponent>
      </PageHeader>
    </section>

    <b-skeleton-table
      v-if="isLoading"
      animation="wave"
      style="margin-top: 2rem"
      :rows="5"
      :columns="8"
      :table-props="{ bordered: true, striped: true }"
    />

    <LeadsTable v-else :list="leads" :isLoading="isLoading" />
  </main>
</template>

<script>
import {
  CNAEFirstSelect,
  MunicipioSelect,
  LeadsTable,
} from '../../modules/leads/components';
import { SelectYear } from '../../ui/selects';
import { BaseButtonComponent } from '../../ui/buttons';
import { PageHeader } from '../../ui/page-header';
import { Api } from '../../vue/api';
const API = new Api();

export default {
  data() {
    return {
      isLoading: false,
      leads: [],
      cnaeList: [],
      municipioList: [],
      minStartActivityYear: null,
      maxStartActivityYear: null,
    };
  },
  components: {
    MunicipioSelect,
    PageHeader,
    CNAEFirstSelect,
    SelectYear,
    BaseButtonComponent,
    LeadsTable,
  },
  computed: {
    computedMaxStartYear() {
      // Caso minStartActivityYear não seja definido, retorna 1694
      return Number(this.minStartActivityYear) || 1694;
    },
    disableSearchButton() {
      return (
        !this.cnaeList.length ||
        !this.municipioList.length ||
        this.isLoading ||
        (this.minStartActivityYear && !this.maxStartActivityYear) ||
        (!this.minStartActivityYear && this.maxStartActivityYear)
      );
    },
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
      });
    },
    validateDates() {
      return (
        (!this.minStartActivityYear && !this.maxStartActivityYear) ||
        (this.minStartActivityYear &&
          this.maxStartActivityYear &&
          this.maxStartActivityYear >= this.minStartActivityYear)
      );
    },
    async getLeads() {
      this.leads = [];
      if (!this.validateDates()) {
        this.showToast(
          'Por favor, selecione um período válido de ano de início da atividade.',
          'Erro',
          'danger',
        );
        return;
      }

      this.isLoading = true;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: '/lead-management/leads',
          method: 'get',
          data: {
            cnaeList: this.cnaeList,
            municipioList: this.municipioList,
            minStartActivityYear: this.minStartActivityYear,
            maxStartActivityYear: this.maxStartActivityYear,
          },
        });

        if (!ok) {
          this.showToast(errors.message, 'Erro', 'danger');
          return;
        }

        if (!model || !model.length) {
          this.showToast('Nenhum lead encontrado.', 'Aviso', 'warning');
          return;
        }

        this.leads = model.map(lead => ({
          name: lead.razao_social,
          primaryCNAECode: lead.cnae_fiscal_principal,
          primaryCNAEDescription: lead.cnae_fiscal_principal_descricao,
          state: lead.uf,
          cityCode: lead.municipio,
          cityDescription: lead.municipio_descricao,
          socialNumber: lead.cnpj,
          cnpjBasico: lead.cnpj_basico,
        }));
      } catch (error) {
        this.showToast('Erro ao buscar leads', 'Erro', 'danger');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
